import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import { queryKeys } from "../../query-keys";

export function useTasks(clubId: string | null, status?: string, assigneeId?: string) {
	return useQuery({
		queryKey: queryKeys.clubPortal.tasks(clubId ?? "", status),
		queryFn: () => clubApi.tasks.list(clubId!, { status, assignee_id: assigneeId }),
		enabled: !!clubId,
	});
}

export function useCreateTask(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: unknown) => clubApi.tasks.create(clubId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "tasks"],
			}),
	});
}

export function useUpdateTask(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ taskId, data }: { taskId: string; data: unknown }) =>
			clubApi.tasks.update(clubId, taskId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "tasks"],
			}),
	});
}

export function useDeleteTask(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (taskId: string) => clubApi.tasks.delete(clubId, taskId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "tasks"],
			}),
	});
}
